import { getMaxDate, getMinDate } from ".";
const checkPlatform = function() {
  if (/android/i.test(navigator.userAgent)) {
    return "1";
  }
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return "2";
  }
};
const isDateInRange = (curr, min, max) => {
  const minDate = getMinDate(min);
  const maxDate = getMaxDate(max);
  const currentDate = new Date(curr.setHours(0, 0, 0, 0)).getTime();
  if (minDate && maxDate)
    return currentDate > minDate && currentDate < maxDate;
  if (minDate)
    return currentDate > minDate;
  if (maxDate)
    return currentDate < maxDate;
  return true;
};
const isWindow = (val) => val === window;
const isDate = (val) => Object.prototype.toString.call(val) === "[object Date]" && !Number.isNaN(val.getTime());
const isLeap = (year) => year % 4 === 0 ? year % 100 !== 0 ? 1 : year % 400 === 0 ? 1 : 0 : 0;
export {
  checkPlatform,
  isDate,
  isDateInRange,
  isLeap,
  isWindow
};
